import { render, staticRenderFns } from "./VisualizarProcessamento.vue?vue&type=template&id=965efd16&lang=pug"
import script from "./VisualizarProcessamento.vue?vue&type=script&lang=js"
export * from "./VisualizarProcessamento.vue?vue&type=script&lang=js"
import style0 from "./VisualizarProcessamento.vue?vue&type=style&index=0&id=965efd16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports